export default {
  title: 'Informații personale',
  buttons: {
    save: 'Salvează',
  },
  toasts: {
    personal_info_updated_successfully: 'Informațiile au fost salvate cu succes',
  },
};
